
import React from "react";
import Layout from "@/components/Layout";
import { SharedFloorPlansList } from "@/components/shared/SharedFloorPlansList";

export default function SharedFloorPlans() {
  return (
    <Layout>
      <div className="container py-8 space-y-6">
        <div>
          <h1 className="text-3xl font-bold">
            <span>Turnles </span>
            <span className="text-green-500">Planner</span>
            <span> - Lesideeën</span>
          </h1>
          <p className="text-muted-foreground mt-2 text-lg">
            Vind de perfecte lesplattegrond voor jouw volgende les
          </p>
        </div>
        <SharedFloorPlansList />
      </div>
    </Layout>
  );
}
